var countries = require('json!../../../../config/countries.json');
var editions = require('json!../../../../config/editions.json');

var hasCountry = function (user) {
  return !!user.account.country;
};

var hasEdition = function (user) {
  // always return true for intolerancia
  return true;
  // // console.log('>>>', user);
  // if (user.permissions.is_admin || user.permissions.is_editor) {
  //   return true
  // }
  // var userEditions = [];
  // _.forIn(editions, function (value, key) {
  //   userEditions.push({
  //     _id: key,
  //     name: value
  //   });
  // });
  // user.editions = []
  // user.account.groups.forEach(function (group) {
  //   if (_.find(userEditions, {_id: group._id})) {
  //     user.editions.push({
  //       _id: group._id,
  //       name: userEditions[group._id]
  //     });
  //   }
  // });
  // return !!user.account.groups && !!user.editions.length;
};

var hasFullName = function (user) {
  return !!user.account.name.full;
};


angular
  .module('services.editionChecker', [
    'resources.User',
    'services.formErrors'
  ])
  .factory('editionChecker', ["$location", "$uibModal", "security", function ($location, $uibModal, security) {
    var dialog = null;
    var handleClose = function () {
      dialog.close();
      dialog = null;
    };
    return {
      check: function (user) {
        // console.log( '>>>', user );
        if ( /*!hasFullName(user) || */ !hasCountry(user) || !hasEdition(user)) {
          dialog = $uibModal.open({
            template: require('../../app/complete-account-info.tpl.html'),
            controller: 'SelectEditionCtrl',
            resolve: {
              user: user
            }
          });
          dialog.result.then(handleClose);
        }
      }
    };
  }])

  .controller('SelectEditionCtrl',
    ["$scope", "$location", "security", "editionResource", "$modalInstance", "User", "user", "formErrors", "growl", function ($scope, $location, security, editionResource, $modalInstance, User, user, formErrors, growl) {
      $scope.countries = [];
      _.forIn(countries, function (value, key) {
        $scope.countries.push({
          _id: key,
          name: value
        });
      });
      $scope.editions = [];
      _.forIn(editions, function (value, key) {
        $scope.editions.push({
          _id: key,
          name: value
        });
      });

      $scope.data = {
        firstname: user.account.name.first,
        lastname: user.account.name.last,
        email: user.email,
        country: _.find($scope.countries, {_id: user.account.country}),
        editions: []
      };
      $scope.data2 = {
        username: user.username,
        email: user.email
      };

      user.account.groups.forEach(function (group) {
        if (editions[group._id]) {
          $scope.data.editions.push({
            _id: group._id,
            name: editions[group._id]
          });
        }
      });


      $scope.hasCountry = function () {
        return hasCountry(user);
      };
      $scope.hasEdition = function () {
        return hasEdition(user);
      };
      $scope.hasFullName = function () {
        return hasFullName(user);
      };
      $scope.save = function () {
        var data = angular.copy($scope.data);
        data.country = data.country._id;

        data.editions = _.map(data.editions, '_id');
        User.completeSignup(data, function (result) {
          $modalInstance.close();
          growl.info('Info saved');
        }, formErrors.growlErrors);

        var data2 = angular.copy($scope.data2);
        data2.email = data.email;
        User.changeLogin(data2, function (result) {
          $scope.data2 = {};
        }, formErrors.growlErrors);
      };
    }]);



// WEBPACK FOOTER //
// ./client/src/common/services/editionChecker.js